import * as React from 'react';
import { Button, IconClose16, InlineText2 } from '@cian/ui-kit';
import { IOffice } from '../../types/offices';
import { OfficeCard } from '../../components/OfficeCard';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';
import { getWorkTime } from '../../utils';
import { BalloonImage } from '../BalloonImage';
import { SubwayInfo } from '../SubwayInfo';
import { TSPTheme } from '../../types/specialProjects/themes';

interface IOfficeMapBalloonProps {
  office: IOffice;
  callbackButtonTheme?: TSPTheme;
}

export function OfficeMapBalloon({ office, callbackButtonTheme }: IOfficeMapBalloonProps) {
  const preparedWorkTime = React.useMemo(() => getWorkTime(office.contacts.workTime), [office.contacts.workTime]);

  return (
    <OfficeCard
      hasClose
      close={<IconClose16 color={!office.image ? 'gray60_100' : 'white_100'} />}
      image={<BalloonImage imageUrl={office.image} newBuildingName={office.name} />}
      title={<InlineText2>{office.name}</InlineText2>}
      address={office.address ? <InlineText2>{office.address}</InlineText2> : null}
      subwayInfo={<SubwayInfo subwayInfo={office.subwayInfo} />}
      workingTime={preparedWorkTime ? <InlineText2>{preparedWorkTime}</InlineText2> : null}
      contacts={
        office.preparedPhone ? (
          <SPThemeWrapper theme={callbackButtonTheme}>
            <Button id={office.id} size="XS">
              Показать контакты
            </Button>
          </SPThemeWrapper>
        ) : null
      }
    />
  );
}
